import { Mapper } from "../../../../../base/utils/mapper";
import { TypeBusinessModel } from "../../../../../domain/models/configuration/company/type-business.model";
import { TypeBusinessEntity } from "../../entities/company/type-business.entity";

export class TypeBusinessImplementationRepositoryMapper extends Mapper<TypeBusinessEntity, TypeBusinessModel> {
    mapFrom(param: TypeBusinessEntity): TypeBusinessModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeBusinessModel): TypeBusinessEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}